/* eslint-disable no-useless-concat */
import axios from "axios";
import { url } from "../utils/url";

const useAxios = axios.create({
    baseURL: url?.baseUrl
});

const requestHandler = (req: any): any => {
    if (localStorage.getItem('usertoken')) {
        req.headers['Authorization'] = 'Token' + ' ' + localStorage.getItem('usertoken');
    }
    return req;
};

const responseHandler = (res: any): any => {
    return res;
};

const errorHandler = (error: any): any => {
    if (error && error?.response?.status === 401) {
        window.location.href = '/login';
    }
    return Promise.reject(error);
};

useAxios.interceptors.request.use(
    (req: any) => requestHandler(req),
    (error: any) => errorHandler(error)
);

useAxios.interceptors.response.use(
    (res: any) => responseHandler(res),
    (error: any) => errorHandler(error)
);

export default useAxios;